module.exports = __webpack_public_path__ + "static/media/tree1.48fad21e.svg";